import { Link, Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { requireAuth, useMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

/** Staff only; everyone else lands back on the dashboard (the api refuses them anyway). */
export const Route = createFileRoute("/app/admin")({
  beforeLoad: async ({ context, location }) => {
    const me = await requireAuth(context.queryClient, location.href);
    if (!me.user.isPlatformAdmin) throw redirect({ to: "/app" });
  },
  component: AdminLayout,
});

const active = { className: "font-semibold underline" };

function AdminLayout() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return (
    <>
      <h1>{t("admin.title")}</h1>
      <nav
        className="my-4 flex flex-wrap gap-4 border-b pb-2 text-sm"
        aria-label={t("admin.title")}
      >
        <Link to="/app/admin" activeOptions={{ exact: true }} activeProps={active}>
          {t("admin.tab.organizations")}
        </Link>
        <Link to="/app/admin/learning" activeProps={active}>
          {t("admin.tab.learning")}
        </Link>
        <Link to="/app/admin/ai-usage" activeProps={active}>
          {t("admin.tab.aiUsage")}
        </Link>
        <Link to="/app/admin/cost" activeProps={active}>
          {t("admin.tab.cost")}
        </Link>
        <Link to="/app/admin/models" activeProps={active}>
          {t("admin.tab.models")}
        </Link>
        <Link to="/app/admin/launch-failures" activeProps={active}>
          {t("admin.tab.launchFailures")}
        </Link>
        <Link to="/app/admin/queues" activeProps={active}>
          {t("admin.tab.queues")}
        </Link>
      </nav>
      <Outlet />
    </>
  );
}
